<!--
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-06-27 15:32:53
 * @LastEditors: zhangyuan zhangyuan@cheyipai.com
 * @LastEditTime: 2022-10-27 11:15:21
 * @FilePath: /report-template/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <keep-alive include=''>
    <router-view/>
  </keep-alive>
  <!-- <router-view v-if='!$route.meta.keepAlive'/> -->
</template>
<style>
    *{
      font-family: 'PingFang SC';
      margin:0;
      padding:0;
      border:0;
    }
    @font-face {
      font-family: 'Rubik';     /* 这个名字可以自己定义 */
      src: url('./assets/image/Alibaba-Rubik.ttf'); /* IE9 Compat Modes */
      src: url('./assets/image/Alibaba-Rubik.ttf')  format('truetype'), /* Safari, Android, iOS */
    }
    @font-face {
      font-family: 'Alibaba PuHuiTi';     /* 这个名字可以自己定义 */
      src: url('./assets/image/Alibaba-PuHuiTi-Bold.ttf'); /* IE9 Compat Modes */
      src: url('./assets/image/Alibaba-PuHuiTi-Bold.ttf')  format('truetype'), /* Safari, Android, iOS */
    }
    html,body {
      -webkit-touch-callout: none; /*系统默认菜单被禁用*/
      -webkit-user-select: none; /*webkit浏览器*/
      -khtml-user-select: none; /*早起浏览器*/
      -moz-user-select: none; /*火狐浏览器*/
      -ms-user-select: none; /*IE浏览器*/
      user-select: none; /*用户是否能够选中文本*/
    }
    input,select {
      -webkit-user-select:auto; /*webkit浏览器*/
      user-select: auto; /*用户是否能够选中文本*/
    }
</style>

